import { useContext } from 'react';

import CurrentlyViewedUserContext from '../../../../src/packages/kakapo-ui-application/contexts/CurrentlyViewedUserContext';

export function useCurrentlyViewedUser() {
	return useContext(CurrentlyViewedUserContext)!;
}
